import SessionTimeoutModalContainer from './SessionTimeoutModalContainer';

export default SessionTimeoutModalContainer;
